import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@/components/Modal";
import { Select } from "@/components/Select";
import { Badge } from "@/components/Badge";
import { Icon } from "@/components/Icon";
import { tasksApi } from "@/lib/api";
import { useToast } from "@/context/ToastContext";

export const ChangeTaskTypeModal = ({ isOpen, task, types, onClose, onSuccess }: any) => {
    const { t } = useTranslation("global");
    const { showSuccess } = useToast();
    const [typeId, setTypeId] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (task) setTypeId(task.type_id ? String(task.type_id) : task.type?.id ? String(task.type.id) : "");
    }, [task]);

    const options = types.map((type: any) => ({
        value: String(type.id),
        label: t(`tasks.types.${type.tag}`) !== `tasks.types.${type.tag}` ? t(`tasks.types.${type.tag}`) : type.name,
        icon: type.icon || (type.tag === "bug" ? "bug" : "clipboardCheck"),
        iconColor: type.tag === "bug" ? "text-rose-500" : "text-primary",
    }));

    const submit = async () => {
        if (!task || !typeId) return;
        setLoading(true);
        try {
            const res = await tasksApi.update(task.id, { type_id: Number(typeId) });
            if (res.result) {
                const selected = types.find((type: any) => String(type.id) === typeId);
                showSuccess(t("tasks.modal_type.success"));
                onSuccess({ ...task, type_id: Number(typeId), type: selected });
                onClose();
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={t("tasks.modal_type.title")} maxWidth="sm" onSubmit={submit} submitLabel={t("common.save")} isSubmitting={loading} submitIcon={<Icon value="check" size={15} />}>
            {task && <div className="text-center mb-5"><Badge value={task.code} /><div className="mt-2 font-semibold">{task.title}</div></div>}
            <Select label={t("tasks.new_modal.type")} options={options} value={typeId} onChange={setTypeId} full />
        </Modal>
    );
};
